module.exports = __webpack_public_path__ + "img/konsultasi-active.493d754.png";